(function () {
  var nav = document.querySelector('.js-nav')
  var headerMenu = document.querySelector('.js-header-menu-trigger')
  headerMenu.addEventListener('click', menuOpen)
  var label = nav.querySelectorAll('.js-nav-label')
  var posY

  if(typeof(FONTPLUS) !== 'undefined') {
    FONTPLUS.attachCompleteEvent(function(e){
      if(e.code) {
        nav.classList.add('is-font-error')
      }
    })
  }

  function menuOpen(){
    headerMenu.removeEventListener('click', menuOpen)
    nav.classList.add('is-show')
    headerMenu.classList.add('is-show')
    window.addEventListener('page-scroll', menuClose)
    headerMenu.addEventListener('click', menuClose)

    for (var i = 0; i < label.length; i++) {
      label[i].addEventListener('click', submenuOpen)
    }

    // スクロール禁止
    posY = window.pageYOffset
    document.body.style.top = -window.pageYOffset + 'px'
    document.body.classList.add('is-fixed')
  }

  function menuClose() {
    window.removeEventListener('page-scroll', menuClose)
    headerMenu.removeEventListener('click', menuClose)
    nav.classList.remove('is-show')
    headerMenu.classList.remove('is-show')
    headerMenu.addEventListener('click', menuOpen)

    for (var i = 0; i < label.length; i++) {
      label[i].removeEventListener('click', submenuOpen)
      label[i].removeEventListener('click', submenuClose)
      label[i].classList.remove('is-show');
      label[i].nextElementSibling.style.height = ''
    }

    // スクロール禁止解除
    document.body.classList.remove('is-fixed')
    document.body.style.top = ''
    window.scrollTo({
      top: posY,
      behavior: 'auto'
    })
  }

  function submenuOpen(e) {
    e.preventDefault()
    e.target.classList.add('is-show');
    e.target.nextElementSibling.style.height = e.target.nextElementSibling.scrollHeight + 'px'
    e.target.addEventListener('click', submenuClose)
    e.target.removeEventListener('click', submenuOpen)
  }

  function submenuClose(e) {
    e.preventDefault()
    e.target.classList.remove('is-show');
    e.target.nextElementSibling.style.height = ''
    e.target.addEventListener('click', submenuOpen)
    e.target.removeEventListener('click', submenuClose)
  }

  window.addEventListener('resize', resize)

  var currentWidth

  function resize() {
    if (currentWidth == window.innerWidth) {
      return
    }

    if(window.innerWidth >= 1200) {
      menuClose()
    }

    currentWidth = window.innerWidth
  }

  
}());